import {
  $can,
  $hasFeature,
  $userHasGameLoyaltyFeature
} from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_Xperience_Hub',
  icon: 'navigation-gamification-dice',
  index: '7',
  isAllowed: () => $hasFeature('enableGamification') && $can('viewProjectItem'),
  isNew: true,
  subItems: [
    {
      sectionName: 'LeftNavigation_Games_Hub',
      index: '7-1',
      routeName: 'GamesHub',
      isAllowed: () => $hasFeature('enableGamification')
    },
    {
      sectionName: 'LeftNavigation_Loyalty_Hub',
      index: '7-2',
      routeName: 'Loyalty',
      isAllowed: () => $userHasGameLoyaltyFeature() && $hasFeature('loyalty')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/gamification.js